import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    *, *::before, *::after {
        margin: 0;
        box-sizing: border-box;
    }

    body {
        background: ${({ theme }) => theme.bg2};
        color: ${({ theme }) => theme.text};
        font-family: Heebo, sans-serif;
        letter-spacing: .6px;
    }

    p {
        font-size: 10pt;
        font-family: Heebo, sans-serif;
        font-weight: 300;
    }

    /* Width for vertical scrollbar and height for horizontal scrollbar */
    ::-webkit-scrollbar {
        width: 5px; /* for vertical scrollbar */
        height: 5px; /* for horizontal scrollbar */
    }

    /* Track */
    ::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.bg}; 
        border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: ${({ theme }) => theme.bg2}; 
    }

    /* Drawer styling */
    .k-drawer{
        position: relative;
        z-index: 10001 !important;
        font-family: Heebo, sans-serif !important;
    }

    /* Essential z-index overrides for calendar and animation containers */
    .k-calendar-container{
        z-index: 10002 !important;
    }

    .k-animation-container{
        z-index: 10002 !important;
        /* No padding override - let Kendo handle button layouts */
    }

    /* Form legend styling */
    .k-form-legend{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    /* Basic form field spacing */
    .k-form-md .k-form-field{
        margin-top: 1rem;
    }

    /* Keep essential upload styling */
    .k-upload-button-wrap{
        text-align: center;
    }

    .k-upload button {
        background-color: #1e2a4e;
        color: #ffffff;
        border: none;
    }

    /* Essential dropzone styling */
    .k-dropzone{
        color: #323130;
        border-color: #323130 !important;
        border-style: dashed !important;
    }

    .k-dropzone-inner{
        border: 0;
        border-radius: 0.5rem;
    }

    /* Tab strip styling */
    .k-tabstrip-items{
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: normal;
    }

    /* Event styling for calendar */
    .k-event{
        color: #1e2a4e !important;
        border-left: 0.3rem solid #1e2a4e !important;
        background-color: rgb(236 239 249) !important;
        font-size: 10pt !important;
        border-radius: 0.3rem !important;
    }

    /* Essential window styling */
    .k-window {
        font-family: Heebo, sans-serif;
    }

    /* Application-specific styling (non-Kendo) */
    .incoming__container .k-form .k-form-field{
        border-bottom: 1px solid rgb(4, 14, 24);
        padding: 0.8rem;
        margin-bottom: 1rem;
        background-color: rgba(4, 14, 24, 0.1);
        border-radius: 0.2rem;
    }

    /* Essential button container styling for application UI */
    .button__container{
        background-color: rgba(236, 239, 249, 0);
    }

    /* Keep essential pager styling */
    .k-pager-wrap .k-pager-numbers .k-link{
        background: rgb(33, 37, 41);
        color: rgb(255, 255, 255);
        border: 0;
        border-radius: 0.2rem;
        margin: 0.1rem;
    }

    .k-pager-wrap .k-pager-numbers .k-current-page .k-link{
        background: rgb(13, 110, 253) !important;
        color: rgb(255, 255, 255) !important;
        border: 0;
    }

    /* Essential table styling */
    .k-table{
        border-radius: 1rem;
    }

    /* Widget title styling */
    .k-widget-title {
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: normal;
        color: rgb(4, 14, 24);
        font-size: 14px;
    }

    /*
    NOTE: All Kendo button, input, and component styling has been removed 
    to allow the Fluent theme to handle component appearance and behavior.
    This ensures filter buttons and other interactive elements work correctly.
    */
`;